import { type Dispatch, type JSX, type SetStateAction, useState } from 'react';

import { type Repub } from '@cx-modules/types';

import { type CustomisableComponentProps, type Subevent } from '../../types';
import { EventRowContent } from '../EventRowContent';

import { Divider, RowWrapper } from './style';

export interface EventRowProps extends CustomisableComponentProps {
  betLocation?: string;
  matchStatsEnabled?: boolean;
  pageTitle?: string;
  repub: Repub;
  requestUrl: string;
  setGroupTitleLabelsMarginRight: Dispatch<SetStateAction<number>>;
  showBottomBorder: boolean;
  showTeamBadges: boolean;
  subevent: Subevent;
}

export const EventRow = ({
  betLocation,
  className,
  matchStatsEnabled = true,
  pageTitle,
  repub,
  requestUrl,
  setGroupTitleLabelsMarginRight,
  showBottomBorder,
  showTeamBadges,
  subevent,
}: EventRowProps): JSX.Element => {
  const [showMatchStats] = useState(false);

  return (
    <>
      <RowWrapper className={className} expand={true} showBottomBorder={showBottomBorder}>
        <EventRowContent
          betLocation={betLocation}
          matchStatsEnabled={matchStatsEnabled}
          matchStatsVisible={showMatchStats}
          pageTitle={pageTitle}
          repub={repub}
          requestUrl={requestUrl}
          setGroupTitleLabelsMarginRight={setGroupTitleLabelsMarginRight}
          showTeamBadges={showTeamBadges}
          subevent={subevent}
        />
      </RowWrapper>
      {showMatchStats && <Divider />}
    </>
  );
};
